export const shippingPolicy = {
    "data": {
        "policy": {
            "id": "sspol_RaG3IgxaCn8Se8BBpePqM",
            "name": "House Policy One",
            "account": {
                "externalAccountID": "1234",
                "externalAccountDomain": "AUCTIONHOUSE",
                // timestamps, etc  
            },
            "flags": {
                "eligible": true,
            },
            // timestamps, etc

            // WIP: terms, origins
            "terms": [
                {
                    "id": "sspol_RaG3IgxaCn8Se8BBpePqM",
                    "name": "House Policy One",
                },
                {
                    "id": "sspol_PqM3IgxaCn8Se8BBpe",
                    "name": "House Policy Two",
                },
                {
                    "id": "sspol_Cn8Se8RaG3IgxaCn8Se8BBpe",
                    "name": "House Policy Three",
                },
                {
                    "id": "sspol_RaG3I3IgxaxaCn8Se8BBpePqM",
                    "name": "House Policy Four",
                }
            ],
            "origins": [
                {
                    "id": "sspol_RaG3IgxaCn8Se8BBpePqM",
                    "name": "1234 No Where Lane",
                },
                {
                    "id": "sspol_PqM3IgxaCn8Se8BBpe",
                    "name": "4825 Some Place Lane",
                },
                {
                    "id": "sspol_Cn8Se8RaG3IgxaCn8Se8BBpe",
                    "name": "2835 Doesnt Exsist Lane",
                },
            ]
        }
    },
    "meta": {
        "reqId": "ssreq_ZFbHojGXEdeM1DfEryQhh"
    }
  };